import {authAxios} from "../api/axiosClient";
import Cookies from 'universal-cookie';
import {listMemberAvailableURL, listMemberOfTeamURL} from "../constants";
const cookies = new Cookies();

export const ListMemberOfTeamApi = (params={})=>{
        const url = listMemberOfTeamURL;
        return authAxios().get(url,{params});
}

export const ListMemberOfTeamAvailableApi = (params={})=>{
        const url = listMemberAvailableURL;
        return authAxios().get(url,{params});
}

